import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Button, Card, CardBody, Col, Row } from 'reactstrap'
import bg1 from '../../../assets/img/generic/condominium.jpg'
import { verifyAccountDeletionRequest } from '../../../helpers/api/accountDeletion'
import { ERROR_RESPONSE } from '../../../helpers/codeResponses/codes'
import Section from '../../common/Section'
import Logo from '../../navbar/Logo'
import { PreloadState } from '../../UI/preloading/PreloadState'

const AccountDeletionVerify = () => {
  const { token } = useParams()
  const [loading, setLoading] = useState(true)
  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    let isMounted = true

    verifyAccountDeletionRequest(token)
      .then(({ data }) => {
        isMounted && setResult(data)
      })
      .catch((err) => {
        const code = err?.data?.code || err?.code
        isMounted &&
          setError(
            code === ERROR_RESPONSE.TOKEN_EXPIRED
              ? 'El enlace de confirmación ya venció. Envía nuevamente el formulario para recibir uno nuevo.'
              : 'El enlace de confirmación no es válido o ya fue utilizado.'
          )
      })
      .finally(() => {
        isMounted && setLoading(false)
      })

    return () => {
      isMounted = false
    }
  }, [token])

  return (
    <Section
      id="account-deletion-verify"
      className="py-0 pt-4"
      image={bg1}
      style={{ backgroundSize: 'cover' }}
      position="center bottom"
      overlay
    >
      <Row className="flex-center min-vh-100 py-6">
        <Col>
          <Row className="justify-content-center">
            <Col sm={12} md={10} lg={6}>
              <Card>
                <Logo to={'/'} classImage="mb-0 mt-4" />
                <CardBody className="fs--1 font-weight-normal p-5 pt-3 text-center">
                  <PreloadState loading={loading} message="Confirmando tu solicitud">
                    {error ? (
                      <>
                        <FontAwesomeIcon
                          icon={faTimesCircle}
                          className="text-danger mb-3"
                          style={{ fontSize: '3rem' }}
                        />
                        <h4>No pudimos confirmar tu solicitud</h4>
                        <p className="mb-4">{error}</p>
                        <Button color="falcon-default" tag={Link} to="/account-deletion">
                          Volver al formulario
                        </Button>
                      </>
                    ) : (
                      <>
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className="text-success mb-3"
                          style={{ fontSize: '3rem' }}
                        />
                        <h4>
                          {result?.already_verified
                            ? 'Tu solicitud ya estaba confirmada'
                            : 'Solicitud confirmada'}
                        </h4>
                        <p className="mb-3">
                          Recibimos la solicitud de eliminación asociada al correo{' '}
                          <b>{result?.email}</b>.
                        </p>
                        <p className="text-600 mb-4">
                          Nuestro equipo la procesará en un plazo máximo de 30 días hábiles y te
                          escribirá a ese mismo correo cuando esté lista.
                        </p>
                        <Button color="falcon-default" tag={Link} to="/">
                          Volver al inicio
                        </Button>
                      </>
                    )}
                  </PreloadState>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Section>
  )
}

export default AccountDeletionVerify
